
export const PageDataState = {    
    Searchs: {
        district_id: {
            type: 'select',
            id: 'district_id',
            label: 'อำเภอ',
            value: '',
            placeholder: 'อำเภอ',
        },
        subdistrict_name: {
            type: 'text',
            id: 'subdistrict_name',
            label: 'ตำบล',
            value: '',
            placeholder: 'ตำบล',
        },
    },
    Inputs: {
        district_id: {
            type: 'select',
            id: 'district_id',
            label: 'อำเภอ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 4,
                maxLength: 4
            },
            error: { status: null, msg: '' }
        },
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: true,
                minLength: 6,
                maxLength: 6
            },
            error: { status: null, msg: '' }
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ตำบล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 3,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
        zip_code: {
            type: 'text',
            id: 'zip_code',
            label: 'รหัสไปรษณีย์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 5
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}